import { FetchApiResponse } from "redux/types";

export enum ProgrammesDumpReportReduxTypes {
    PROGRAMMES_DUMP_REPORT="@@report/PROGRAMMES_DUMP_REPORT",
    PROGRAMMES_DUMP_REPORT_SUCCESS="@@report/PROGRAMMES_DUMP_REPORT_SUCCESS",
    PROGRAMMES_DUMP_REPORT_ERROR="@@report/PROGRAMMES_DUMP_REPORT_ERROR"
}

export type ProgrammesDumpReportActionDispatch = {
    type: ProgrammesDumpReportReduxTypes.PROGRAMMES_DUMP_REPORT;
    payload: any;
}

export type ProgrammesDumpReportReducerDispatch = {
    type:
        | ProgrammesDumpReportReduxTypes.PROGRAMMES_DUMP_REPORT
        | ProgrammesDumpReportReduxTypes.PROGRAMMES_DUMP_REPORT_SUCCESS
        | ProgrammesDumpReportReduxTypes.PROGRAMMES_DUMP_REPORT_ERROR;

    payload: {
        data?: FetchApiResponse<ProgrammesDumpReport>;
        error?: string;
    }
}

export type ProgrammesDumpReport = {
    id: string,
    financierId: string,
    userId: string,
    type: string,
    status: number,
    updatedOn: string,
    createdOn: string
}

export type CreateProgrammesDumpReportRequest = {
    payload: {
        programExternalId?: string
    },
    type: string
}

export type CreateProgrammesDumpReduxState = {
    loading?: boolean,
    data?: {},
    error?: string | null;
}